module.exports = __webpack_public_path__ + "img/logo-regular.663bfb8a.png";